module.exports = {
  archiveRoomsFeature:
    process.env.REACT_APP_PROJECT_ARCHIVE_ROOM_FEATURE === 'true',
  editAndDeleteMsgFeature:
    process.env.REACT_APP_PROJECT_EDIT_DELETE_MESSAGE_FEATURE === 'true'
}
